module.exports = __webpack_public_path__ + "static/img/ma1.5fdd13e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ma1.gif
// module id = 2gKQ
// module chunks = 1